import { useTranslation } from "react-i18next";
import { Avatar, Box, Skeleton, Typography } from "@mui/material";

import { VerifiedIcon } from "../../../../../../../assets/icons/MUI/LayoutIcons";

import { ServiceProvider } from "../../../../../api/types/topServiceProviders.types";
import { ServiceRequester } from "../../../../../api/types/topServiceProviders.types";
import { useUserDataFormatter } from "../../../../../../User/hooks/useUserDataFormatter";

export const UserDetails = ({ user, title }: { user: ServiceRequester | ServiceProvider; title: string }) => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });

  const { fullName, media, firstTwoChr, role, cityName, countryName, isVerified } = useUserDataFormatter(user);
  return (
    <Box sx={styles.container}>
      <Box sx={styles.avatarContainer}>
        <Avatar src={media} sx={styles.avatar}>
          {firstTwoChr}
        </Avatar>
        {isVerified && <VerifiedIcon sx={styles.verifiedIcon} />}
      </Box>
      <Box sx={styles.userDetails}>
        <Typography sx={styles.fullName}>{fullName}</Typography>
        <Typography sx={styles.details}>
          {role} {Boolean(cityName) && `• ${cityName}`} {Boolean(countryName) && `• ${countryName}`}
        </Typography>
        <Typography sx={styles.details}>{t(title)}</Typography>
      </Box>
    </Box>
  );
};

export const UserDetailsLoader = () => {
  return (
    <Box sx={styles.container}>
      <Skeleton variant="circular" width={52} height={52} />
      <Box sx={styles.userDetails}>
        <Skeleton variant="text" width={150} height={24} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width={200} height={18} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width={120} height={18} />
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    flex: 1,
    maxWidth: { xs: "100%", md: "calc(50% - 4px)" },
    display: "flex",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    padding: "16px",
    alignItems: "center",
    gap: "12px",
  },
  avatarContainer: {
    position: "relative",
    flexShrink: 0,
  },
  avatar: {
    width: "52px",
    height: "52px",
  },
  userDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    maxWidth: "calc(100% - 64px)",
    minWidth: 0,
    overflow: "hidden",
  },
  fullName: {
    color: "#1A1C21",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  details: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  verifiedIcon: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 50%)",
    zIndex: 10,
  },
};
